import React from 'react';
import { MapPin, Plane } from 'lucide-react';
import { locations } from '../data/mock';

const Locations = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#2c2825] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 border border-[#faf8f5] rounded-full" />
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 border border-[#faf8f5] rounded-full" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center">
          <span className="text-xs tracking-[0.3em] uppercase text-[#c9b896] mb-4 block">
            Our Reach
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-[#faf8f5] mb-6" style={{ fontWeight: 400 }}>
            {locations.title}
          </h2>
          <div className="w-16 h-px bg-[#c9b896] mx-auto mb-8" />
          <p className="text-lg text-[#faf8f5]/80 mb-12">
            {locations.focus}
          </p>

          {/* Location Cards */}
          <div className="flex flex-wrap justify-center gap-8 lg:gap-16">
            {locations.regions.map((region, index) => (
              <div
                key={index}
                className="group flex items-center gap-4 px-8 py-6 border border-[#c9b896]/30 hover:border-[#c9b896] transition-all duration-300"
              >
                <MapPin size={24} className="text-[#c9b896]" strokeWidth={1.5} />
                <span className="font-display text-xl text-[#faf8f5] group-hover:text-[#c9b896] transition-colors duration-300" style={{ fontWeight: 400 }}>
                  {region}
                </span>
              </div>
            ))}
          </div>

          {/* Decorative Plane */}
          <div className="mt-16 flex justify-center">
            <Plane size={48} className="text-[#c9b896]/30" strokeWidth={1} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Locations;
